import { AutoComplete, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { Label } from 'common/components';

export type AtribuicaoSearchProps<T> = {
  name: string;
  label?: string;
  size?: number;
  value: T;
  error?: any;
  className?: string;
  getOptionLabel: (option: T) => string;
  onSelect: (name: string, value: T) => void;
  onSearch: (search: string) => AxiosPromise<PagedResponse<T>>;
};

const AtribuicaoSearch = <T,>({
  name,
  value,
  error,
  onSelect,
  onSearch,
  size = 4,
  getOptionLabel,
  label = 'Atribuição',
  className = 'form-group'
}: AtribuicaoSearchProps<T>) => {
  return (
    <>
      <div className={`col-md-${size}`}>
        <div className={className}>
          <Label>{label}</Label>
          <AutoComplete<T>
            name={name}
            value={value}
            autoFocus={false}
            onSearch={onSearch}
            onSelect={onSelect}
            getOptionLabel={getOptionLabel}
            className={!!error ? 'error' : ''}
            getOptionValue={atribuicao => atribuicao['id']}
          />
          {!!error && <span className="help-message">{error}</span>}
        </div>
      </div>
    </>
  );
};

export { AtribuicaoSearch };
